import _ from 'lodash';
import { getRecoil, setRecoil } from 'recoil-nexus';

import { enhanceNoteLoadingState } from 'components/practice/charts/ClinicalNote/MyScribeAI/state';
import state from 'components/state';

const defaultClinicalNote = {
  notes: '',
  subjective: '',
  objective: '',
  present_illness: '',
  other_complaints: '',
  assessment: '',
  plan: '',
  exam: '',
  test: '',
  epn: {
    riskFactors: {
      narrative: ''
    },
    session: {
      narrative: ''
    },
    sessionQuotesAndContents: '',
    activeSymptoms: {
      narrative: ''
    },
    functionalImpairment: {
      narrative: ''
    },
    interventions: {
      narrative: ''
    },
    progress: {
      narrative: ''
    }
  },
  goals: '',
  goals_narrative: '',
  mha: {
    riskAndCoMorbidities: '',
    timeFrames: ''
  },
  hpi: {
    narrative: ''
  },
  ros: {
    narrative: ''
  }
};

const updateClinicalNote = (data) => {
  try {
    if (data?.response === undefined && data?.task_id) {
      setRecoil(state.intelligenceAiState, (ps) => ({
        ...ps,
        activeTaskIds: [...ps.activeTaskIds, data?.task_id]
      }));
    } else {
      const {
        vertical,
        form_name: initialFormName,
        form_type,
        response,
        task_id,
        abort = false,
        done = false
      } = data;

      if (!abort) {
        const isNotCustomForm = !form_type?.includes('custom_form_narrative');
        let form_name = initialFormName;

        if (form_name === 'progress') {
          form_name = 'epn';
        }
        if (form_name === 'intake') {
          form_name = 'mha';
        }

        if (['soap', 'hp', 'clinical_narrative'].includes(vertical) && isNotCustomForm) {
          if (defaultClinicalNote?.[form_name]?.[form_type]?.['narrative'] !== undefined) {
            setRecoil(state.clinicalNote, (ps) => ({
              ...ps,
              [form_name]: {
                ...ps?.[form_name],
                [form_type]: {
                  ...ps?.[form_name]?.[form_type],
                  narrative: response
                }
              }
            }));
          } else if (defaultClinicalNote?.[form_name]?.[form_type] !== undefined) {
            setRecoil(state.clinicalNote, (ps) => ({
              ...ps,
              [form_name]: {
                ...ps?.[form_name],
                [form_type]: response
              }
            }));
          } else if (defaultClinicalNote?.[form_type]?.['narrative'] !== undefined) {
            setRecoil(state.clinicalNote, (ps) => ({
              ...ps,
              [form_type]: {
                ...ps?.[form_type],
                narrative: response
              }
            }));
          } else if (defaultClinicalNote?.[form_type] !== undefined) {
            setRecoil(state.clinicalNote, (ps) => ({
              ...ps,
              [form_type]: response
            }));
          }
        }

        const newAiClinicalNoteState = getRecoil(state.intelligenceAiState);
        if (newAiClinicalNoteState?.timeoutTimeout)
          clearTimeout(newAiClinicalNoteState?.timeoutTimeout);

        setRecoil(state.intelligenceAiState, (ps) => {
          let newTaskIds = ps.activeTaskIds;

          if (!!done) {
            const index = newTaskIds.findIndex((item) => item === task_id);
            if (index > -1) {
              const newValue = [...newTaskIds];
              newValue.splice(index, 1);
              newTaskIds = newValue;
            }
          }

          return {
            ...ps,
            activeTaskIds: newTaskIds,
            loading: !!!done,
            response: data?.response,
            path: `${vertical}.${data?.form_name}.${data?.form_type}`
          };
        });

        if (!!data?.done) {
          setRecoil(enhanceNoteLoadingState, (prev) => {
            const index = prev.findIndex((item) => item === form_type);
            if (index === -1) return prev;

            const newValue = [...prev];
            newValue.splice(index, 1);
            return newValue;
          });
        }
      } else {
        setRecoil(state.intelligenceAiState, (ps) => ({
          ...ps,
          activeTaskIds: [],
          loading: false,
          response: '',
          path: ''
        }));

        setRecoil(enhanceNoteLoadingState, []);
      }
    }
  } catch (e) {
    console.log(e);
  }
};

export default updateClinicalNote;
